import React, { Fragment } from 'react';

///////  FOOTER INDEX //////
const Index = () => {
  return (
    <Fragment>
      <div style={{ height: '320px', background: '#333333' }}></div>
      <div style={{ height: '320px', background: '#474747' }}></div>
    </Fragment>
  );
};

export default Index;
